import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of Terminal List of type IManifestPro
 */

export const manifestProDetailsApi = async (manifestNumber: string, partialHeaders?: any) => {
  try {
    let headers = {
      "Content-Type": "application/json",
      "OSD-Module-Name": "myAssignments",
      "OSD-Section-Name": "manifestProDetails",
      "OSD-Action-Type": "get",
      ...partialHeaders,
    };
    const response = await axios.get(`${getUrl(ApiType.MANIFEST_PRO_DETAILS)}/${manifestNumber}`, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.manifestProDetails, { badRequestOrder: "errorsFirst" });
  }
};
